import { Injectable, inject } from '@angular/core';
import { FieldSelectors } from '@cropx-web/screens/field/state/field.state';
import { ApiGatewayService } from '@cropx-web/services/api-gateway/ApiGatewayService';
import { ManagementZones } from '@cropx-web/services/api-gateway/MachineDataApiService';
import { ApiService } from '@cropx-web/services/network/ApiService';
import { TranslateService } from '@ngx-translate/core';
import {
  Action,
  Selector,
  State,
  StateContext,
  Store,
  createPropertySelectors,
} from '@ngxs/store';

import { GenerateManagementZonesSelectors } from '../../state/generate-management-zones.state';

export enum VriBaseZones {
  soilCropZones,
  managementZones,
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace CreateManagementZones {
  const type = 'CreateManagementZones';

  export class SetManagementZones {
    static readonly type = `[${type}] SetManagementZones`;
    constructor(public zones: ManagementZones) {}
  }

  export class SetName {
    static readonly type = `[${type}] SetName`;
    constructor(public name: string) {}
  }
}

export interface CreateManagementZonesModel {
  managementZones: ManagementZones;
  name: string;
}

@State<CreateManagementZonesModel>({
  name: 'createManagementZones',
  defaults: {
    managementZones: null,
    name: null,
  },
})
@Injectable()
export class CreateManagementZonesState {
  private store = inject(Store);
  private api = inject(ApiGatewayService);
  private oldApi = inject(ApiService);
  private translate = inject(TranslateService);

  @Action(CreateManagementZones.SetManagementZones)
  setManagementZones(
    ctx: StateContext<CreateManagementZonesModel>,
    action: CreateManagementZones.SetManagementZones,
  ): void {
    ctx.patchState({
      managementZones: action.zones,
    });
  }

  @Action(CreateManagementZones.SetName)
  setName(
    ctx: StateContext<CreateManagementZonesModel>,
    action: CreateManagementZones.SetName,
  ): void {
    ctx.patchState({
      name: action.name,
    });
  }
}

export class CreateManagementZonesSelectors {
  static slices = createPropertySelectors<CreateManagementZonesModel>(
    CreateManagementZonesState,
  );

  @Selector([
    FieldSelectors.slices.geometryLoading,
    GenerateManagementZonesSelectors.slices.generateZonesLoading,
  ])
  static mapLoading(...loading: boolean[]): boolean {
    return loading.some((l) => l);
  }
}
